export default "__VITE_ASSET__byqNnEMW__"